$(document).ready(function () {
  $(document).on("click", ".img-description-banner__info", function () {
    $(this)
      .find(".img-description-banner__info__tooltip")
      .toggleClass("show_tooltip");
    $(this).parents(".img-description-banner").toggleClass("tooltip-active");
    console.log("sssss");
  });

  $(".price-rating-wrapper .styled-card__rating").click(function () {
    $("html, body").animate(
      {
        scrollTop: $("#judgeme_product_reviews").offset().top,
      },
      2000
    );
  });

  $("#back-to-top").click(function () {
    $("html, body").animate(
      {
        scrollTop: 0,
      },
      1000
    );
  });

  $(".product-form__input input[type=radio]+label[data-img]").click(
    function () {
      let img = $(this).attr("data-img");
      let thumbnail = $(this).attr("data-thumbnail");
      console.log("Img: ", img, "Thumbnail: ", thumbnail);
      $(".variant-main-img").find("img").attr("src", img);
      $(".variant-main-img").find("img").attr("srcset", img);
      $("#variant-thumbnail-img").find("img").attr("src", thumbnail);
      swiper2.slideTo(0, 400);
      swiper.slideTo(0, 400);
    }
  );

  $(document).on("click", ".delete-link", function () {
    let link = $(this).attr("data-item-index");
    $(`#CartDrawer-Remove-${link}, #CartDrawer-Remove-${link} button`).click();
    console.log("test");
  });

  window.onscroll = function () {
    scrollFunction();
  };

  function scrollFunction() {
    if (
      document.body.scrollTop > 20 ||
      document.documentElement.scrollTop > 20
    ) {
      $("#back-to-top").fadeIn();
    } else {
      $("#back-to-top").fadeOut();
    }
  }
});

$(window).scroll(function () {
  clearTimeout($.data(this, "scrollTimer"));
  $.data(
    this,
    "scrollTimer",
    setTimeout(function () {
      // do something
      let ele = document.querySelector(".hidden-container-for-sticky-button");
      let visibility = elementInViewport2(ele);
      console.log(visibility, "visibility");
      if (!visibility) {
        $(".sticky-bottom-button").fadeIn(100);
        if ($(".klaviyo-bis-trigger").length) {
          let clone = $(".klaviyo-bis-trigger").clone();
          $(".sticky-bottom-button__btn-wrapper").append(clone);
        }
      } else {
        $(".sticky-bottom-button").fadeOut(100);
        if (
          $(".sticky-bottom-button__btn-wrapper .klaviyo-bis-trigger").length
        ) {
          $(".sticky-bottom-button__btn-wrapper .klaviyo-bis-trigger").remove();
        }
      }
    }, 50)
  );
});

const screenWidth_s = $(window).width();
let getDirection_s = "vertical";
if (screenWidth_s <= 749) {
  getDirection_s = "horizontal";
}

function elementInViewport2(el) {
  if (!el) {
    return;
  }
  var top = el.offsetTop;
  var left = el.offsetLeft;
  var width = el.offsetWidth;
  var height = el.offsetHeight;

  while (el.offsetParent) {
    el = el.offsetParent;
    top += el.offsetTop;
    left += el.offsetLeft;
  }

  return (
    top < window.pageYOffset + window.innerHeight &&
    left < window.pageXOffset + window.innerWidth &&
    top + height > window.pageYOffset &&
    left + width > window.pageXOffset
  );
}

function checkingElement(selectorIs, functionName, timer, args = "") {
  try {
    var divCheckingInterval = setInterval(
      function () {
        if (document.querySelector(selectorIs)) {
          clearInterval(divCheckingInterval);
          if (typeof functionName !== "undefined" && functionName) {
            window[functionName](args ? args : "");
          }
          return true;
        }
      },
      timer != "" ? timer : 250
    );
    return false;
  } catch (err) {
    console.log(`ERROR checkingElement`, err.message);
  }
}

async function updateCartItems(updates, cart) {
  const formData = {
    updates: updates,
    sections: cart
      .getSectionsToRender()
      .map((section) => section.id)
      .join(","),
  };

  return fetch("/cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => response.json())
    .then((data) => {
      cart.renderContents(data);
    })
    .catch((error) => {
      console.error("Failed to update cart:", error);
    });
}

async function changeQuantity(id, quantity, cart) {
  const formData = {
    id: id.toString(),
    quantity: quantity,
    sections: cart
      .getSectionsToRender()
      .map((section) => section.id)
      .join(","),
  };

  return fetch("/cart/change.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => response.json())
    .then((data) => {
      cart.renderContents(data);
    })
    .catch((error) => {
      console.error("Failed to remove products from cart:", error);
    });
}

async function clearCart(cart) {
  return fetch("/cart/clear.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
    },
    body: JSON.stringify({
      sections: cart
        .getSectionsToRender()
        .map((section) => section.id)
        .join(","),
    }),
  })
    .then((response) => response.json())
    .then((data) => {
      cart.renderContents(data);
    })
    .catch((error) => {
      console.error("Failed to clear the cart:", error);
    });
}

class DiscountPromotion extends HTMLElement {
  constructor() {
    super();
    this.clipboardButton = this.querySelector(
      ".discount-promotion__discount-content"
    );
    this.discount = this.querySelector("#discount");
    this.copyIcon = this.querySelector(".icon--copy-icon");
    this.checkIcon = this.querySelector(".icon--check");

    this.init();
  }

  init() {
    this.clipboardButton.addEventListener("click", () => {
      this.copyToClipboard();
    });
  }

  copyToClipboard() {
    navigator.clipboard
      .writeText(this.discount.textContent)
      .then(() => {
        this.copyIcon.classList.add("hidden");
        this.checkIcon.classList.remove("hidden");
        setTimeout(() => {
          this.checkIcon.classList.add("hidden");
          this.copyIcon.classList.remove("hidden");
        }, 2000);
      })
      .catch((err) => {
        console.error("Could not copy text: ", err);
      });
  }
}

// Define the new custom element
customElements.define("discount-promotion", DiscountPromotion);

class DiscountInput extends HTMLElement {
  constructor() {
    super();

    this.applyButton = document.querySelector("#apply-discount-btn");
    this.discountCodeInput = document.querySelector("#discount-code-input");
    this.discountCodeWrapper = document.querySelector(".discount-code-wrapper");
    this.totalCartSelector = document.querySelector(".total-cart");
    this.discountCodeValue = document.querySelector(".discount-code-value");
    this.discountCodeError = document.querySelector(".discount-code-error");
    this.clearButton = document.querySelector("#clear-discount-btn");
    this.toggleButton = this.querySelector(".accordion__toggle");
    this.accordion = this.querySelector(".accordion");
    this.content = this.querySelector(".accordion__content");
    this.discountInformation = this.querySelector(".discount-information");
    this.init();
  }

  init() {
    if (localStorage.getItem("discountCode")) {
      const savedDiscount = JSON.parse(localStorage.getItem("discountCode"));
      this.applyDiscountCode(savedDiscount.code, true);
    }

    if (this.applyButton) {
      this.applyButton.addEventListener("click", (e) => this.handleApply(e));
    }

    if (this.toggleButton) {
      this.toggleButton.addEventListener("click", () => this.toggleAccordion());
    }

    if (this.clearButton) {
      this.clearButton.addEventListener("click", (e) => this.clearDiscount(e));
    }
  }

  toggleAccordion() {
    const isExpanded = this.accordion.getAttribute("aria-expanded") === "true";
    this.accordion.setAttribute("aria-expanded", !isExpanded);
    this.content.hidden = isExpanded;
  }

  handleApply(e) {
    e.preventDefault();
    const code = this.discountCodeInput.value.trim();

    if (code) {
      this.discountCodeInput.style.border = "";
      this.applyDiscountCode(code);
    } else {
      this.discountCodeInput.style.border = "1px solid red";
    }
  }

  applyDiscountCode(code, isInitialLoad = false) {
    this.setLoadingState(true);
    this.discountInformation.removeAttribute("hidden");
    this.discountInformation.textContent = "Code wird geprüft";

    fetch(`/discount/${code}`)
      .then(() => fetch("/cart?view=discount"))
      .then((res) => res.text())
      .then((data) => {
        const dataObject = JSON.parse(data);
        const appliedCodes = dataObject.discounts.map((i) =>
          i.title.toLowerCase()
        );

        if (appliedCodes.includes(code.toLowerCase())) {
          fetch(window.location.pathname + "?sections=cart-drawer")
            .then((res) => res.json())
            .then((res) => {
              const placeholder = document.createElement("div");
              placeholder.innerHTML = res["cart-drawer"];

              document.querySelector("cart-drawer").innerHTML =
                placeholder.querySelector("cart-drawer").innerHTML;

              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "cart-items",
                data: dataObject,
              });
            });
        } else {
          this.handleInvalidDiscount();
        }
      })
      .catch(() => {
        if (!isInitialLoad) {
          this.showError("An error occurred. Please try again.");
        }
      })
      .finally(() => this.setLoadingState(false));
  }

  handleInvalidDiscount() {
    if (this.discountInformation) {
      this.discountInformation.classList.add("text--highlight");
      this.discountInformation.textContent = "Falscher Rabattcode";
      setTimeout(() => {
        this.discountInformation.setAttribute("hidden", "");
        this.discountInformation.classList.remove("text--highlight");
      }, 1500);
    }
  }

  setLoadingState(isLoading) {
    if (this.applyButton) {
      this.applyButton.style.pointerEvents = isLoading ? "none" : "all";
      this.applyButton.disabled = isLoading ? true : false;
    }
  }

  clearDiscount(e) {
    e.preventDefault();
    this.clearLocalStorage();
  }

  clearLocalStorage() {
    if (this.discountCodeWrapper)
      this.discountCodeWrapper.style.display = "none";
    if (this.totalCartSelector) {
      const savedDiscount = localStorage.getItem("discountCode");
      if (savedDiscount) {
        this.totalCartSelector.textContent =
          JSON.parse(savedDiscount).totalCart;
      }
    }

    localStorage.removeItem("discountCode");
    if (this.discountCodeValue) this.discountCodeValue.textContent = "";
    if (this.discountCodeError) this.discountCodeError.textContent = "";
  }

  showError(message) {
    if (this.discountCodeError) {
      this.discountCodeError.textContent = message;
    }
  }
}

// Define the custom element
customElements.define("discount-input", DiscountInput);

class CartGoodies extends HTMLElement {
  constructor() {
    super();

    this.cart =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");

    this.goodiePopover = document.querySelector("#GoodiePopover");
    this.checkoutForms = document.querySelectorAll("#CartDrawer-Form");
    this.allGoodies = this.querySelectorAll("[data-goodie]");

    this.unsubscribeCartUpdate = null;
  }

  get thresholdConsideration() {
    return this.dataset.thresholdConsideration;
  }

  connectedCallback() {
    this.unsubscribeCartUpdate = subscribe(
      PUB_SUB_EVENTS.cartUpdate,
      (event) => {
        this.handleCartChange(event);
      }
    );

    if (this.goodiePopover) {
      this.checkoutForms.forEach((form) => {
        form.addEventListener("submit", this.handleFormSubmit.bind(this));
      });
    }
  }

  disconnectedCallback() {
    if (this.unsubscribeCartUpdate) {
      this.unsubscribeCartUpdate();
      this.unsubscribeCartUpdate = null; // Clear the reference
    }

    if (this.goodiePopover) {
      this.checkoutForms.forEach((form) => {
        form.removeEventListener("submit", this.handleFormSubmit.bind(this));
      });
    }
  }

  handleFormSubmit(event) {
    if (event.submitter.id !== "CartDrawer-Checkout--new") {
      return;
    }

    event.preventDefault();
    this.openPopover();
  }

  openPopover() {
    this.goodiePopover.setAttribute("aria-expanded", true);
    this.goodiePopover.setAttribute("open", "");
  }

  closePopover() {
    this.goodiePopover.setAttribute("aria-expanded", false);
    this.goodiePopover.removeAttribute("open");
  }

  async handleCartChange(event) {
    if (!event?.data) return;

    const cartItems = event.data.items;
    const cartTotal =
      this.thresholdConsideration === "before_discounts"
        ? event.data.original_total_price
        : event.data.total_price;
    const updates = {}; // Store all cart updates (id -> quantity)
    let allGoodiesInCart = true;

    this.allGoodies.forEach((goodie) => {
      const id = parseInt(goodie.dataset.variant);
      const threshold = parseInt(goodie.dataset.threshold);

      const goodieItem = cartItems.find((item) => item.id === id);

      if (!goodieItem) {
        allGoodiesInCart = false;
        return;
      }

      // Ensure quantity is max 1
      if (goodieItem.quantity > 1) {
        updates[id] = 1;
      }

      // Remove if below threshold
      if (cartTotal < threshold) {
        updates[id] = 0;
      }
    });

    // If only goodies are in the cart, clear it
    if (allGoodiesInCart && cartItems.length === this.allGoodies.length) {
      clearCart(this.cart);
      return;
    }

    // Perform update if there are changes
    if (Object.keys(updates).length > 0) {
      await updateCartItems(updates, this.cart);
    }
  }
}

customElements.define("cart-goodies", CartGoodies);

class AtcButton extends HTMLElement {
  constructor() {
    super();
    this.cart =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");

    this.submitButton = this.querySelector("button")
      ? this.querySelector("button")
      : this;
  }

  get variantId() {
    return parseInt(this.dataset.variant);
  }

  connectedCallback() {
    this.submitButton.addEventListener("click", this.handleSubmit.bind(this));
  }

  disconnectedCallback() {
    this.submitButton.removeEventListener(
      "click",
      this.handleSubmit.bind(this)
    );
  }

  handleSubmit(event) {
    event.preventDefault();

    this.submitButton.setAttribute("aria-disabled", true);
    this.submitButton.classList.add("loading");

    if (this.submitButton.querySelector(".loading-overlay__spinner")) {
      this.submitButton
        .querySelector(".loading-overlay__spinner")
        .classList.remove("hidden");
    }

    this.addItemToCart();
  }

  async addItemToCart() {
    let formData = {
      items: [
        {
          id: this.variantId,
          quantity: 1,
        },
      ],
      sections_url: window.location.pathname,
      sections: this.cart.getSectionsToRender().map((section) => section.id),
    };

    return fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.submitButton.setAttribute("aria-disabled", false);
        this.submitButton.classList.remove("loading");

        if (this.submitButton.querySelector(".loading-overlay__spinner")) {
          this.submitButton
            .querySelector(".loading-overlay__spinner")
            .classList.add("hidden");
        }
        this.cart.renderContents(data);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }
}

customElements.define("atc-button", AtcButton);

class RelatedSets extends HTMLElement {
  constructor() {
    super();

    this.productTitles = Array.from(this.querySelectorAll(".related_title"));
  }

  connectedCallback() {
    this.setTitleElementHeight = this.setTitleElementHeight.bind(this);
    this.setTitleElementHeight();

    window.addEventListener("resize", this.setTitleElementHeight);
  }

  setTitleElementHeight() {
    if (!this.productTitles.length) return;

    const heights = this.productTitles.map((element) => element.offsetHeight);
    const maxHeight = Math.max(...heights);
    const allEqual = heights.every((height) => height === maxHeight);
    if (!allEqual) {
      this.productTitles.forEach((element) => {
        element.style.height = `${maxHeight}px`;
      });
    }
  }
}

customElements.define("related-sets", RelatedSets);

class CountdownBar extends HTMLElement {
  constructor() {
    super();
    this.interval = null;
  }

  connectedCallback() {
    this.startCountdown();
  }

  disconnectedCallback() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  startCountdown() {
    const countDownDate = new Date(
      this.getAttribute("data-counter-date")
    ).getTime();

    // Cache elements to avoid redundant queries
    const daysElement = this.querySelector("#countdown-bar-days");
    const hoursElement = this.querySelector("#countdown-bar-hrs");
    const minutesElement = this.querySelector("#countdown-bar-mins");
    const secondsElement = this.querySelector("#countdown-bar-secs");

    // Helper function to ensure double digits
    const formatNumber = (num) => String(num).padStart(2, "0");

    this.interval = setInterval(() => {
      const now = Date.now();
      const distance = Math.max(countDownDate - now, 0);

      const days = Math.floor(distance / 86400000); // 1000 * 60 * 60 * 24
      const hours = Math.floor((distance % 86400000) / 3600000); // 1000 * 60 * 60
      const minutes = Math.floor((distance % 3600000) / 60000); // 1000 * 60
      const seconds = Math.floor((distance % 60000) / 1000);

      daysElement.textContent = formatNumber(days);
      hoursElement.textContent = formatNumber(hours);
      minutesElement.textContent = formatNumber(minutes);
      secondsElement.textContent = formatNumber(seconds);

      if (distance === 0) clearInterval(this.interval);
    }, 1000);
  }
}

customElements.define("countdown-bar", CountdownBar);

class SliderElement extends HTMLElement {
  static get observedAttributes() {
    return ["data-config"];
  }

  constructor() {
    super();
    this.swiper = null;
    this.swiperConfig = this.dataset.config
      ? JSON.parse(this.dataset.config)
      : {};
    this.adjustHeightSelector = this.dataset.adjustSwiperHeight;
    this.resizeTimeout = null;
  }

  connectedCallback() {
    if (!this.swiper) {
      this.initSwiper();
    }

    if (this.adjustHeightSelector) {
      this.adjustElementsHeight();
      window.addEventListener("resize", this.debounceResize.bind(this));
    }
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
    window.removeEventListener("resize", this.debounceResize.bind(this));
  }

  initSwiper() {
    this.swiper = new Swiper(this, this.swiperConfig);
  }

  debounceResize() {
    clearTimeout(this.resizeTimeout);
    this.resizeTimeout = setTimeout(() => {
      this.adjustElementsHeight();
    }, 250);
  }

  adjustElementsHeight() {
    if (!this.swiper || !this.adjustHeightSelector) return;

    let maxHeight = 0;
    const elements = this.querySelectorAll(this.adjustHeightSelector);

    elements.forEach((element) => {
      element.style.height = "auto";
    });

    elements.forEach((element) => {
      const elementHeight = element.offsetHeight;
      maxHeight = Math.max(maxHeight, elementHeight);
    });

    elements.forEach((element) => {
      element.style.height = `${maxHeight}px`;
    });

    this.swiper.update();
  }
}

customElements.define("slider-element", SliderElement);
